import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, SkipForward, RotateCcw, Trophy } from "lucide-react";
import { sfx } from "../../lib/audio";
import { useRoom } from "../../lib/zhuyinRoom";
import { RoomShell } from "../../components/zhuyin/RoomUI";
import { LearnPanel } from "../../components/zhuyin/LearnPanel";

const key = (c) => `zq_marathon_${c}`;

export default function ZhuyinMarathon() {
  const nav = useNavigate();
  const { cards, childId } = useRoom();
  const [i, setI] = useState(() => Number(localStorage.getItem(key(childId)) || 0));
  const [traced, setTraced] = useState(false);
  const go = (n) => { setI(n); setTraced(false); localStorage.setItem(key(childId), String(n)); };
  if (!cards) return <RoomShell title="連續練習 37 個" testid="zhuyin-marathon-page" />;
  const total = cards.length;
  if (i >= total) {
    return (
      <RoomShell title="連續練習 37 個" testid="zhuyin-marathon-page">
        <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="flex flex-col items-center gap-6 py-16" data-testid="marathon-finished">
          <Trophy size={96} className="text-amber-500" />
          <h2 className="font-brush text-5xl text-[var(--vermilion)]">三十七個注音都練完了！</h2>
          <div className="flex gap-4">
            <button data-testid="marathon-restart-btn" onClick={() => go(0)} className="kid-btn px-8 bg-white border-2 border-[#b9dcf0] text-[#14507f] text-xl font-round flex items-center gap-2"><RotateCcw /> 再練一次</button>
            <button data-testid="marathon-progress-btn" onClick={() => nav("/zhuyin/progress")} className="kid-btn px-8 bg-[#1D6FB8] text-white text-xl font-round">看我的進度</button>
          </div>
        </motion.div>
      </RoomShell>
    );
  }
  const z = cards[i];
  return (
    <RoomShell title="連續練習 37 個" testid="zhuyin-marathon-page"
      right={<span className="font-round text-xl text-[#14507f]" data-testid="marathon-count">{i + 1} / {total}</span>}>
      <div className="h-3 rounded-full bg-[#d6ebf7] mb-6 overflow-hidden"><div className="h-full bg-[#1D6FB8] transition-[width] duration-500" style={{ width: `${(i / total) * 100}%` }} /></div>
      <LearnPanel z={z} childId={childId} onTraced={() => setTraced(true)} />
      <div className="flex justify-center gap-4 mt-8">
        <button data-testid="marathon-skip-btn" onClick={() => go(i + 1)} className="kid-btn px-6 bg-white border-2 border-[#b9dcf0] text-stone-500 text-xl font-round flex items-center gap-2"><SkipForward /> 跳過</button>
        <button data-testid="marathon-next-btn" onClick={() => { sfx("tap"); go(i + 1); }}
          className={`kid-btn px-10 text-2xl font-round flex items-center gap-2 ${traced ? "bg-[var(--jade)] text-white" : "bg-amber-100 text-[var(--tea)]"}`}>
          {traced ? "好棒！下一個" : "下一個"} <ChevronRight />
        </button>
      </div>
    </RoomShell>
  );
}
